import { render } from "./FormVideo.vue?vue&type=template&id=fc20a5f8"
import script from "./FormVideo.vue?vue&type=script&lang=js"
export * from "./FormVideo.vue?vue&type=script&lang=js"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__